import React from 'react';
import { PolarArea } from 'react-chartjs-2';

const PolarGraph = React.forwardRef((props, ref) => {
    const options = {
        maintainAspectRatio: true,
        responsive: true,
        legend: {
            display: true,
            position: 'bottom',
        },
        title: {
            display: true,
            text: props.text,
        },
    };

    return <PolarArea ref={ref} data={props.data} options={options} />;
});

export default PolarGraph;
